import React from 'react';
import { Download } from 'lucide-react';

const pct = (v) => (v == null ? '—' : `${v}%`);

// Conversion by source page; uses each request's current status. Converted = Confirmed or Completed.
export const ConsultationConversion = ({ sources = [], onExport }) => {
  const rows = sources.filter((s) => s.count > 0);
  const tot = rows.reduce((a, s) => ({ count: a.count + s.count, confirmed: a.confirmed + s.confirmed, completed: a.completed + s.completed }), { count: 0, confirmed: 0, completed: 0 });
  const totPct = tot.count ? Math.round((1000 * (tot.confirmed + tot.completed)) / tot.count) / 10 : null;
  return (
    <details className="bg-white border border-neutral-200 rounded-lg group" data-testid="consult-conversion">
      <summary className="cursor-pointer select-none px-4 py-3 text-sm font-medium text-neutral-800 flex items-center justify-between" data-testid="consult-conversion-toggle">
        <span>Conversion by source <span className="font-normal text-neutral-500">· overall {pct(totPct)}</span></span>
        <span className="text-xs text-neutral-400 group-open:hidden">Show</span><span className="text-xs text-neutral-400 hidden group-open:inline">Hide</span>
      </summary>
      <div className="px-4 pb-4">
        <p className="text-xs text-neutral-500 mb-2" data-testid="consult-conversion-definition"><b>Converted = Confirmed or Completed</b>, based on each request's current status. Uses the selected date range (submission date).</p>
        {onExport && <button type="button" onClick={onExport} className="mb-2 inline-flex items-center gap-1.5 text-xs font-medium text-neutral-700 border border-neutral-300 rounded px-2.5 py-1.5 hover:border-neutral-900" data-testid="consult-conversion-export"><Download className="w-3.5 h-3.5" />Export conversion CSV</button>}
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="text-xs text-neutral-500 text-left border-b border-neutral-200">
              <tr><th className="py-2 pr-3">Source page</th><th className="py-2 px-3 text-right">Total</th><th className="py-2 px-3 text-right">Confirmed</th><th className="py-2 px-3 text-right">Completed</th><th className="py-2 pl-3 text-right">Conversion</th></tr>
            </thead>
            <tbody>
              {rows.length ? rows.map((s) => (
                <tr key={s.key} className="border-b border-neutral-100" data-testid={`consult-conversion-row-${s.key.replace(/[^a-z0-9]+/gi, '-')}`}>
                  <td className="py-2 pr-3">{s.title}{s.path && <span className="block text-xs text-neutral-400">{s.path}</span>}</td>
                  <td className="py-2 px-3 text-right tabular-nums">{s.count}</td>
                  <td className="py-2 px-3 text-right tabular-nums">{s.confirmed}</td>
                  <td className="py-2 px-3 text-right tabular-nums">{s.completed}</td>
                  <td className="py-2 pl-3 text-right tabular-nums font-medium">{pct(s.conversion_pct)}</td>
                </tr>
              )) : <tr><td colSpan={5} className="py-6 text-center text-neutral-400">No consultations in this date range.</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </details>
  );
};
